import { call, put, select, takeLatest } from 'redux-saga/effects'
import {
  fetchPartialReport as fetchPartialReportApi,
  fetchReportThreshold as fetchReportThresholdApi,
  postDetails as postDetailsApi,
  sendVerificationCode as sendVerificationCodeApi,
  verifyCode as verifyCodeApi
} from 'api/leadGenApi'
import {
  EMAIL_SENT,
  LOAD_PARTIAL_REPORT,
  LOAD_REPORT_THRESHOLD,
  loadPartialReportFailed,
  loadPartialReportFinished, loadReportThreshold,
  loadReportThresholdFailed,
  loadReportThresholdFinished,
  POST_DETAILS,
  postDetails,
  postDetailsFailed,
  postDetailsFinished,
  SEND_VERIFICATION_CODE,
  sendVerificationCode,
  sendVerificationCodeFailed,
  sendVerificationCodeFinished,
  SUBMIT_DETAILS,
  VERIFY_CODE,
  verifyCodeFailed,
  verifyCodeFinished
} from 'store/actions/leadgenAction'
import { selectDetails, selectLeadGen, selectReportThreshold } from 'store/selectors/leadgenSelector'
import { createPostDetailsRequest, createSendVerificationRequest, createVerifyCodeRequest } from 'utils/leadgenUtil'

import { selectCountryCode } from 'store/selectors/configurationSelector'
import { selectSearchConfig, selectSearchProperty } from 'store/selectors/searchSelector'
import { loadConfigurationHandler } from 'store/sagas/searchSaga'
import { openNewTab } from 'utils/browserUtil'

// WORKERS //
export function * emailSentHandler() {
  const { displayInBrowser } = yield select(selectSearchConfig)
  const { reportCode } = yield select(selectLeadGen)

  if (displayInBrowser) {
    yield call(openNewTab, `/dpr/${reportCode}`)
  }
}

export function * submitDetailsHandler() {
  const { verificationEnabled, verificationType } = yield select(selectSearchConfig)
  const isMobileVerificationEnabled = verificationEnabled && verificationType === 'sms'

  yield call(loadReportThresholdHandler)

  const { data: { status }, status: { isError } } = yield select(selectReportThreshold)

  if (!status || isError) {
    return
  }

  if (isMobileVerificationEnabled) {
    yield put(sendVerificationCode())
  } else {
    yield put(postDetails())
  }
}

export function * postDetailsHandler() {
  try {
    const property = yield select(selectSearchProperty)
    const config = yield select(selectSearchConfig)
    const countryCode = yield select(selectCountryCode)
    const details = yield select(selectDetails)

    const body = yield call(createPostDetailsRequest, {
      config, countryCode, details, property
    })

    const response = yield call(postDetailsApi, body)
    const data = response.data

    yield put(postDetailsFinished(data))
  } catch (e) {
    yield put(postDetailsFailed(e.code))
  }
}

export function * sendVerificationCodeHandler({ payload: { isResend, mobileNumber } }) {
  try {
    const config = yield select(selectSearchConfig)
    const countryCode = yield select(selectCountryCode)
    let details = yield select(selectDetails)
    if (mobileNumber) {
      details = { ...details, mobileNumber }
    }

    const body = yield call(createSendVerificationRequest, {
      config, countryCode, details
    })

    const response = yield call(sendVerificationCodeApi, body)
    const data = response.data

    yield put(sendVerificationCodeFinished({ ...data, isResend, mobileNumber }))
  } catch (e) {
    yield put(sendVerificationCodeFailed(e.code))
  }
}

export function * loadPartialReportHandler({ payload }) {
  try {
    yield call(loadConfigurationHandler, { payload })
    const countryCode = yield select(selectCountryCode)
    const { propertyId } = yield select(selectSearchProperty)
    const response = yield call(fetchPartialReportApi, payload, countryCode, propertyId)
    const data = response.data

    yield put(loadPartialReportFinished(data))
    yield put(loadReportThreshold())
  } catch (e) {
    yield put(loadPartialReportFailed(e.code))
  }
}

export function * loadReportThresholdHandler() {
  try {
    const { integratorId } = yield select(selectSearchConfig)
    const response = yield call(fetchReportThresholdApi, integratorId)
    const data = response.data

    yield put(loadReportThresholdFinished(data))
  } catch (e) {
    yield put(loadReportThresholdFailed(e.code))
  }
}

export function * verifyCodeHandler({ payload }) {
  try {
    const config = yield select(selectSearchConfig)
    const countryCode = yield select(selectCountryCode)
    const property = yield select(selectSearchProperty)
    let details = yield select(selectDetails)

    details = yield call(createPostDetailsRequest, {
      config, countryCode, details, property
    })
    const body = yield call(createVerifyCodeRequest, details, payload)

    const response = yield call(verifyCodeApi, body)
    const data = response.data

    yield put(verifyCodeFinished(data))
  } catch (e) {
    yield put(verifyCodeFailed(e.code))
  }
}

// WATCHER //
export default function * watchLeadGenSaga() {
  yield takeLatest(EMAIL_SENT, emailSentHandler)
  yield takeLatest(SUBMIT_DETAILS, submitDetailsHandler)
  yield takeLatest(POST_DETAILS, postDetailsHandler)
  yield takeLatest(SEND_VERIFICATION_CODE, sendVerificationCodeHandler)
  yield takeLatest(VERIFY_CODE, verifyCodeHandler)
  yield takeLatest(LOAD_PARTIAL_REPORT, loadPartialReportHandler)
  yield takeLatest(LOAD_REPORT_THRESHOLD, loadReportThresholdHandler)
}
